import { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

import { getProductBySku } from 'redux/products/actions';
import { getProductBySku as getProductVariantBySku } from 'redux/products/reducers';

// eslint-disable-next-line import/no-cycle
import AddToCart from './components/AddToCart';

class BuyButtonSku extends Component {
  componentDidMount() {
    this.getProductVariant();
  }

  getProductVariant = () => {
    const { props } = this;
    const { sku } = this.props;
    props.getProductBySku(sku);
  };

  render() {
    const { settings, product, node, sku } = this.props;
    if (!settings.data || !product) {
      return null;
    }
    const variant = product.variants.find((v) => v.sku === sku);
    if (!variant) {
      return null;
    }
    const fakeProduct = { ...product };
    fakeProduct.variants = [variant];
    const analytics = {
      viewType: 'Buy Button'
    };

    return ReactDOM.createPortal(
      <>
        <AddToCart
          key={variant.id}
          product={fakeProduct}
          settings={settings}
          analytics={analytics}
        />
      </>,
      node
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  product: getProductVariantBySku(state.product, ownProps.sku),
  settings: state.setting
});

export default connect(mapStateToProps, {
  getProductBySku
})(BuyButtonSku);
